<section class="tw-w-[350px] tw-m-5">
  <div>
    <p class="tw-text-[16px] tw-mb-0 tw-pb-4">
      {{ "pages.roles.form.editRoleConfirmation.inRole" | translate }}
      <b> {{ editRoleChanges.roleName }}</b>
      {{
        "pages.roles.form.editRoleConfirmation.theFollowingChangesWillBeApplied"
          | translate
      }}
      :
    </p>

    <p
      class="tw-font-medium text-danger tw-mb-1"
      *ngIf="editRoleChanges.deletedClaimsCount"
    >
      <b class="tw-text-[16px] tw-font-black">
        {{ editRoleChanges.deletedClaimsCount }}</b
      >
      {{
        "pages.roles.form.editRoleConfirmation.accessIsRemoved" | translate
      }}
      .
    </p>

    <p
      class="tw-font-medium text-danger"
      *ngIf="editRoleChanges.deletedOrganizationCount"
    >
      <b class="tw-text-[16px] tw-font-black">
        {{ editRoleChanges.deletedOrganizationCount }}</b
      >
      {{
        "pages.roles.form.editRoleConfirmation.theOrganizationIsDeleted"
          | translate
      }}
      .
    </p>

    <p
      class="tw-mb-2 border-top tw-pt-3"
      *ngIf="editRoleChanges.deletedOrganizationCount"
    >
      {{
        "pages.roles.form.editRoleConfirmation.listOfOrganizationsToBeDeleted"
          | translate
      }}
      :
    </p>

    <p class="tw-font-medium tw-text-[14px]">
      {{ editRoleChanges.deletedOrganizationNames?.join(" , ") }}
    </p>

    <div class="alert alert-danger tw-font-medium">
      <p class="tw-mb-0">
        <i class="fas fa-exclamation-circle tw-mx-1"></i>
        <span class="tw-font-bold">{{ "common.warning" | translate }} :</span>
        {{ "pages.roles.form.editRoleConfirmation.description1" | translate }} .
      </p>
    </div>

    <!-- confirm By Writing Text -->
    <div>
      <div class="tw-mt-3 tw-w-full m-auto">
        <div class="tw-flex flex-column">
          <!-- <span class="tw-font-medium">{{"messages.confirmText"|translate}}</span> -->
          <p class="tw-mb-2">
            {{
              "pages.roles.form.editRoleConfirmation.enterTheNumberBelowToConfirmTheChanges"
                | translate
            }}
            .
          </p>
          <span
            class="tw-p-3 bg-light tw-text-center tw-font-medium tw-mt-2 rounded"
            copyToClipboard
            >{{ randomNum }}</span
          >
        </div>
        <div>
          <input
            type="text"
            [maxlength]="4"
            max="4"
            class="form-control tw-mt-2 tw-text-center"
            [(ngModel)]="typingText"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-justify-between tw-items-center tw-mt-5">
    <!-- cancel -->
    <a
      mat-ripple
      class="btn btn-secondary tw-mx-[5px] button-shadow w-75"
      (click)="onClose()"
    >
      {{ "common.cancel" | translate }}
    </a>

    <!-- Confirmation -->
    <button
      [disabled]="+typingText != randomNum"
      mat-ripple
      class="btn btn-success button-shadow tw-w-full btn-hover-rise"
      (click)="onSubmit()"
    >
      {{ "common.confirmation" | translate }}
      <i class="fas fa-check tw-mt-1 tw-mr-1"></i>
    </button>
  </div>
</section>
